+/* Catalog-only presentation; Shopify owns variant, price, inventory and cart state. */
(() => {
  'use strict';
  function boot() {
    document.querySelectorAll('[data-nspire-catalog]').forEach(root => {
      if (root.dataset.catalogReady) return;
      root.dataset.catalogReady = 'true';
      const normalizePayment = () => {
        root.querySelectorAll('.sternify-payment-icons img[alt]').forEach(icon => {
          const match = icon.alt.match(/^(.*?) payment icon$/);
          if (match && root.dataset.paymentIconLabelTemplate) icon.alt = root.dataset.paymentIconLabelTemplate.replace('{brand}', match[1]);
        });
        const heading = root.querySelector('.st_appblock_wrapper [class$="-secure"] > span');
        if (heading && heading.textContent !== root.dataset.secureCheckoutLabel) heading.textContent = root.dataset.secureCheckoutLabel;
        const icon = root.querySelector('.sternify-payment-icon-ideal');
        if (icon && root.dataset.idealWeroLogo && icon.getAttribute('src') !== root.dataset.idealWeroLogo) {
          icon.src = root.dataset.idealWeroLogo; icon.removeAttribute('srcset'); icon.alt = 'iDEAL | Wero';
        }
      };
      normalizePayment();
      new MutationObserver(normalizePayment).observe(root, {childList: true, subtree: true});
      root.addEventListener('click', event => {
        const open = event.target.closest('[data-catalog-size-open]');
        if (open) {
          const dialog = root.querySelector('#' + CSS.escape(open.getAttribute('aria-controls')));
          if (!dialog) return;
          if (!dialog.dataset.catalogBound) {
            dialog.dataset.catalogBound = 'true';
            dialog.addEventListener('close', () => open.focus());
            dialog.addEventListener('click', click => {
              if (click.target !== dialog) return;
              const box = dialog.getBoundingClientRect();
              if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
            });
          }
          if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
        }
        const close = event.target.closest('[data-catalog-size-dialog] [data-dialog-close]');
        if (close) {
          const dialog = close.closest('dialog');
          if (dialog.close) dialog.close(); else dialog.removeAttribute('open');
        }
      });
      root.addEventListener('change', event => {
        if (!event.target.matches('[data-catalog-complement-variant]')) return;
        const variants = event.target;
        const price = variants.closest('[data-catalog-complement]').querySelector('[data-catalog-complement-price]');
        if (price) price.textContent = variants.selectedOptions[0].dataset.price;
      });
      function bindGallery() {
      const gallery = root.querySelector('[data-catalog-gallery]');
      if (!gallery || gallery.dataset.catalogGalleryReady) return;
      gallery.dataset.catalogGalleryReady = 'true';
      const track = gallery.querySelector('[data-catalog-track]');
      const photos = [...gallery.querySelectorAll('[data-catalog-photo]')];
      const thumbs = [...gallery.querySelectorAll('[data-catalog-thumb]')];
      const count = gallery.querySelector('[data-catalog-count]');
      const previous = gallery.querySelector('[data-catalog-prev]');
      const next = gallery.querySelector('[data-catalog-next]');
      const zoom = gallery.querySelector('[data-catalog-zoom]');
      if (!track || !photos.length) return;
      let index = 0, opener;
      let layoutFrame = null, disposed = false;
      const visiblePhotos = () => photos.filter(photo => !photo.hidden && photo.offsetWidth > 0 && photo.getClientRects().length);
      const geometry = () => {
        const items = visiblePhotos();
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        const first = items[0]?.offsetLeft || 0;
        return { items, max, positions: items.map(photo => Math.max(0, Math.min(max, photo.offsetLeft - first))) };
      };
      const move = target => {
        const state = geometry();
        if (!state.items.length) return;
        target = Math.max(0, Math.min(state.items.length - 1, target));
        track.scrollTo({ left: state.positions[target], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const step = direction => {
        const state = geometry();
        const left = Math.max(0, Math.min(state.max, track.scrollLeft));
        const positions = direction < 0 ? state.positions.slice().reverse() : state.positions;
        const destination = positions.find(position => direction < 0 ? position < left - 1 : position > left + 1);
        track.scrollTo({ left: destination ?? (direction < 0 ? 0 : state.max), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      const update = () => {
        const state = geometry();
        if (!state.items.length) return;
        const left = Math.max(0, Math.min(state.max, track.scrollLeft));
        index = state.max > 1 && left >= state.max - 1 ? state.items.length - 1 : state.positions.reduce((best, position, i) => Math.abs(position - left) < Math.abs(state.positions[best] - left) ? i : best, 0);
        if (count) count.textContent = `${index + 1} / ${state.items.length}`;
        const selected = photos.indexOf(state.items[index]);
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === selected)));
        if (previous) previous.disabled = left <= 1;
        if (next) next.disabled = state.max <= 1 || left >= state.max - 1;
        const trust = gallery.querySelector('[data-gallery-trust]');
        if (trust) trust.hidden = left > 1;
      };
      thumbs.forEach((thumb, originalIndex) => thumb.addEventListener('click', () => {
        const visibleIndex = visiblePhotos().indexOf(photos[originalIndex]);
        if (visibleIndex >= 0) move(visibleIndex);
      }));
      previous?.addEventListener('click', () => step(-1));
      next?.addEventListener('click', () => step(1));
      const navigate = event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
      };
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', navigate);
      const reflow = () => {
        layoutFrame = null;
        if (!gallery.isConnected) return cleanup();
        const state = geometry();
        if (track.scrollLeft > state.max) track.scrollTo({ left: state.max, behavior: 'auto' });
        update();
      };
      const schedule = () => {
        if (!disposed && layoutFrame === null) layoutFrame = requestAnimationFrame(reflow);
      };
      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      const mediaObserver = new MutationObserver(schedule);
      const unload = event => {
        if (event.target === gallery || event.target?.contains(gallery)) cleanup();
      };
      function cleanup() {
        if (disposed) return;
        disposed = true;
        if (layoutFrame !== null) cancelAnimationFrame(layoutFrame);
        resizeObserver?.disconnect();
        mediaObserver.disconnect();
        window.removeEventListener('resize', schedule);
        root.removeEventListener('variant:update', schedule);
        track.removeEventListener('load', schedule, true);
        track.removeEventListener('scroll', update);
        track.removeEventListener('keydown', navigate);
        document.removeEventListener('shopify:section:unload', unload);
      }
      resizeObserver?.observe(track);
      mediaObserver.observe(track, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
      window.addEventListener('resize', schedule, { passive: true });
      root.addEventListener('variant:update', schedule);
      track.addEventListener('load', schedule, true);
      document.addEventListener('shopify:section:unload', unload);
      update();
      photos.forEach(photo => photo.addEventListener('click', event => {
        if (!zoom?.showModal) return;
        event.preventDefault(); opener = photo;
        const image = zoom.querySelector('[data-catalog-zoom-image]');
        image.src = photo.href; image.alt = photo.querySelector('img').alt;
        zoom.showModal();
      }));
      zoom?.querySelector('[data-dialog-close]')?.addEventListener('click', () => zoom.close());
      zoom?.addEventListener('click', event => {
        if (event.target !== zoom) return;
        const box = zoom.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) zoom.close();
      });
      zoom?.addEventListener('close', () => opener?.focus());
      update();
      }
      function refreshPresentation() {
        root.querySelectorAll('[data-catalog-size]').forEach(size => {
          const button = size.querySelector('[data-catalog-size-open]');
          const picker = root.querySelector('variant-picker');
          if (!button || !picker) return;
          const legends = [...picker.querySelectorAll('legend')];
          const legend = legends.find(node => /size|maat|taille|größe|talla/i.test(node.textContent));
          if (legend) {
            legend.classList.add('nspire-catalog-size-legend');
            if (!legend.querySelector('[data-catalog-size-legend-copy]')) {
              const copy = button.cloneNode(true);
              copy.hidden = false;
              copy.removeAttribute('hidden');
              copy.setAttribute('data-catalog-size-legend-copy', '');
              legend.appendChild(copy);
            }
            button.hidden = true;
          } else {
            button.hidden = false;
          }
        });
        bindGallery();
      }
      refreshPresentation();
      new MutationObserver(refreshPresentation).observe(root, {childList:true, subtree:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

